import ManageAuthor from '@ecm/capability/ManageAuthor'
import { parseContentfulAuthor } from '@ecm/data/Author'
import appUseContentful from '@ecm/effect/app/UseContentful'

export const appManageAuthor: ManageAuthor = {
  getAuthors: async () => appUseContentful.getEntries('author', parseContentfulAuthor),
}

export default appManageAuthor
